import { useEffect, useState } from 'react';
import Reactivations from './Reactivations';
import { IAssets } from 'Model/IAssets';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { getFileName, popupInitialData } from 'utils';
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction';
import TransferAction from 'Store/Component/Transfer/TransferAction';
import { setReactivationAssetDetails } from 'Store/AssetManagement/AssetNumber/AssetNumberAction';
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import RejectedBee from "../../../../../../assets/images/PenndingApproval/Rejected Bee.png";
import confirmationBee from '../../../../../../assets/images/Confirmation Bee.svg';
import { v1 as uuid } from "uuid";
import Moment from 'moment';
import { CONSTANTS } from 'client/utils/constants';
import { APIToReact } from 'Service/Transfer/ObjectStructure';
import { setDeleteCartOrder } from 'Store/OrderManagement/Order/OrderAction';
import { setTransferOrderById } from 'Store/Transfer/Transfer/TransferOrderByIdAction';
import pendingOrderOperations from 'redux/PendingOrder/operations';
import OrderDispatch from 'Store/OrderManagement/Order/OrderDispatch'
import { resetAllAssetOrderData } from 'client/utils/AssetUtil';
import navOperations from "redux/Navigation/operations";

const ReactivationsContainer = (props?: any) => {

    const {
        quantity,
        setShowCart,
        mobile,
        setShowCreateRequisition,
        setShowCartClicked,
        onCancelClick,
        isRevertChanges,
        setIsRevertChanges,
        setSuccessAlert,
        showCart
    } = props;
    const dispatch = useDispatch();
    const assetFieldList = [
        "assetNumber",
        "color",
        "currentLicensePlateNo",
        "reactivationComments",
        "odometerHourMeter",
        "attachments",
    ]

    const initialState: IAssets = {
        requestIndex: 0,
        requestType: '',
        assetIndex: 1,
        assetNumber: '',
        unitNumber: '',
        model: '',
        costCenterNo: '',
        manufacturerName: '',
        dateDisposed: '',
        modelYear: '',
        color: '',
        description: '',
        serialNumber: '',
        licensePlateNumber: '',
        monthlyAmount: '',
        monthRemaining: 0,
        equipmentClass: '',
        equipmentClassDesc: '',
        eqStatus: '',
        eqStatusDesc: '',
        netBookedValue: '',
        odometerHourMeter: '',
        estimatedDispositionPrice: 0,
        conditionRating: '',
        conditionComment: '',
        openCloseAccordian: false,
        assetError: '',
        odometerHourMeterError: '',
        overallConditionError: '',
        overallConditionCommentError: '',
        estimatedDispositionPriceError: '',
        toolTip: '',
        isExist: false,
        isValid: false,
        isAttachmentsRequired: false,
        attachments: [],
        reactivationColorError: '',
        currentLicensePlateNo: '',
        currentLicensePlateError: '',
        reactivationComments: '',
        reactivationCommentsError: '',
        attachmentsError: '',
        receivingCostCenter: null,
        receivingCostCenterError: ''
    }
    const { id } = useParams();
    const dispatchUploadAttachments = UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
    const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);
    const cancelOrderRequest = pendingOrderOperations.dispatchCancelOrderRequest(dispatch);
    const dispatchSetIsOrderCanceled = pendingOrderOperations.dispatchSetIsOrderCanceled(dispatch);
    const dispatchGetDeleteCartOrderById = OrderDispatch.dispatchGetDeleteCartOrder(dispatch);
    const dispatchNav = navOperations.dispatchNav(dispatch);
    const navigate = useNavigate();

    const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);
    const [WarningPopupcontent, setWarningPopupcontent] = useState<any>(popupInitialData);
    const [cancelPopupContent, setCancelPopupContent] = useState<any>(popupInitialData);
    const [assetDetailList, setAssetDetailList] = useState<any>([initialState]);
    const [isAssetNumberValid, setIsAsserNumberValid] = useState(false);
    const [isAssetBtnClicked, setIsAssetBtnClicked] = useState(false);
    const [isAddAssetClicked, setIsAddAssetClicked] = useState(false);
    const [attachmentError, setAttachmentError] = useState<string>("");
    const [documentList, setDocumentList] = useState<any>([]);
    const [attachmentsList, setAttachmentsList] = useState<any>([]);
    const [addNewAssetAlert, setAddNewAssetAlert] = useState(false);
    const [isAttachmentBtnClicked, setIsAttachmentBtnClicked] = useState<any>([]);
    const [showDispositionInfoAlert, setShowDispositionInfoAlert] = useState(false);
    const [isEditOrder, setIsEditOrder] = useState(false);
    const [isCancelRequestClicked, setIsCancelRequestClicked] = useState(false);

    const {
        assetDetails,
        docList,
        reactivationAssets,
        cartAssets,
        transferOrderByIdData,
        isOrderCanceled,
        cartOrderDelete,
        getUserDetails,
        headerNav
    }: any = useSelector((state?: any) => ({
        assetDetails: state.AssetNumber.reacivationAssetDetails,
        docList: state.UploadAttachmentsReducer.list,
        reactivationAssets: state.TransferReducer.assets,
        cartAssets: state.TransferReducer.cartAssets,
        transferOrderByIdData: state.TransferOrderReducer.transferOrderByIdData,
        isOrderCanceled: state.PendingOrder.isOrderCanceled,
        cartOrderDelete: state.OrderReducer.cartOrderDelete,
        getUserDetails: state.UserProfile.getUserDetails,
        headerNav: state.nav.headerNav
    }));

    useEffect(() => {
        if (id) {
            setShowCartClicked(true);
            setShowCart(true);
            updateAllState();
            setIsEditOrder(true);
        } else {
            setIsEditOrder(false);
            let assetDetailListTemp = [];
            for (let i = 1; i <= quantity; i++) {
                const asset: IAssets = JSON.parse(JSON.stringify(initialState));
                asset.assetIndex = i - 1;
                assetDetailListTemp.push(asset);
            }
            setAssetDetailList(assetDetailListTemp);
            setDocumentList(docList)
            dispatch(TransferAction.setReactivationRequestData([{
                requestIndex: 0,
                requestType: CONSTANTS.REACTIVATION,
                expand: true
            }]));
        }
    }, [])

    useEffect(() => {
        if (isRevertChanges && id) {
            updateAllState();
            setIsRevertChanges(false);
        }
    }, [isRevertChanges])

    useEffect(() => {
        setAttachmentsList(docList);
        setDocumentList(docList);
    }, [docList]);

    useEffect(() => {
        setTimeout(() => {
            setAddNewAssetAlert(false)
        }, 3000)
    }, [addNewAssetAlert])

    useEffect(() => {
        if (showDispositionInfoAlert) {
            setTimeout(() => {
                setShowDispositionInfoAlert(false)
            }, 30000)
        }
    }, [showDispositionInfoAlert])

    useEffect(() => {
        let isUpdated = false;
        assetDetailList.forEach((item: any) => {
            const findAsset = reactivationAssets?.filter((i: any) => i?.assetNumber === item?.assetNumber);
            if (findAsset?.length > 0) {
                const tempAsset = findAsset[0];
                assetFieldList.forEach(element => {
                    if (item[element] != tempAsset[element]) {
                        isUpdated = true;
                    }
                })
                if (item?.attachments?.length != tempAsset?.attachments?.length) {
                    isUpdated = true
                }
            } else {
                isUpdated = true;
            }
        });
        dispatch(TransferAction.setIsCartNotUpdated(isUpdated));
    }, [assetDetailList])

    useEffect(() => {
        if (cartAssets?.length) {
            let tempAssets = assetDetailList?.length > 0 ? assetDetailList : [];

            //check if asset exist in cart
            cartAssets?.forEach((asset: any) => {
                tempAssets.forEach((childAsset: any) => {
                    if (childAsset?.assetNumber === asset?.assetNumber) {
                        childAsset.isExist = asset.isExist;
                        // sync assetError from cartAssets so submit-time validation errors appear in the Asset# input
                        if (asset.assetError !== undefined) {
                            childAsset.assetError = asset.assetError;
                        }
                    }
                });
            });

            //delete asset from list when deleted from cart
            if (cartAssets?.length === reactivationAssets?.length && reactivationAssets.length != assetDetailList?.length) {
                const newTempAsset = JSON.parse(JSON.stringify(tempAssets))
                tempAssets = [];
                cartAssets?.forEach((asset: any) => {
                    const temp = newTempAsset.filter((item: any) => item?.assetNumber === asset?.assetNumber);
                    if (temp) {
                        tempAssets.push(temp[0]);
                    }
                });
            }

            setAssetDetailList(tempAssets);
        }
    }, [cartAssets])

    useEffect(() => {
        if ((isOrderCanceled.approval || cartOrderDelete) && isCancelRequestClicked) {
            setIsCancelRequestClicked(false);
            let decriptionTxt = (
                <div>
                    <p>Order Cancelled Successfully</p>
                </div>
            );
            setCancelPopupContent({
                ...cancelPopupContent,
                titleImg: RejectedBee,
                title: "CANCEL ORDER",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                isCommentboxVisible: false,
                isCommentBoxRequire: false,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    dispatch(RequisitionAction?.setIsChangesOccured(false))
                    dispatch(TransferAction.setIsChangesOccuredInCart(false))
                    dispatchSetIsOrderCanceled(false)
                    dispatchNav(headerNav);
                    navigate('/ordermanagement')
                    resetAllAssetOrderData(dispatch);
                    dispatch(setDeleteCartOrder(false));
                    dispatch(setTransferOrderById({}));
                    dispatch(TransferAction.setAfeOrderByIdData({}))
                },
            });
        } else if ((!isOrderCanceled.approval || !cartOrderDelete) && isCancelRequestClicked) {
            setIsCancelRequestClicked(false);
            let decriptionTxt = (
                <div>
                    <p>Order Cancelled Failed</p>
                </div>
            );
            setCancelPopupContent({
                ...cancelPopupContent,
                titleImg: RejectedBee,
                title: "CANCEL ORDER",
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: decriptionTxt,
                isCommentboxVisible: false,
                isCommentBoxRequire: false,
                outlineBtnText: "Close",
                isSingleConfirmationBtn: true,
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                    dispatch(setDeleteCartOrder(false))
                },
            });
        }
    }, [isOrderCanceled?.approval, cartOrderDelete])

    const updateAllState = () => {
        let assetDetailListTemp: any = [];
        let assetsListTemp = reactivationAssets?.length > 0 ? JSON.parse(JSON.stringify(reactivationAssets)) : []
        assetsListTemp.forEach((asset: any, index: any) => {
            asset.assetIndex = index;
            assetDetailListTemp.push(asset);
        });
        if (assetsListTemp.length === 0) {
            for (let i = 1; i <= quantity; i++) {
                const asset: IAssets = JSON.parse(JSON.stringify(initialState));
                asset.assetIndex = i - 1;
                assetDetailListTemp.push(asset);
                dispatch(TransferAction.setReactivationRequestData([{
                    requestIndex: 0,
                    requestType: CONSTANTS.REACTIVATION,
                    expand: true
                }]));
            }
        } else {
            setShowCart(true);
            setIsEditOrder(true);
            setIsAssetBtnClicked(false);
            if (mobile) {
                setShowCreateRequisition(false)
                setShowCartClicked(false)
            }
            else {
                setShowCartClicked(true)
                setShowCreateRequisition(true)
            }
        }
        dispatch(TransferAction.setAssetData(assetsListTemp));
        setAssetDetailList(assetDetailListTemp);
    }

    const hideDialog = () => {
        setPopupcontent({ ...Popupcontent, isDialogVisible: false })
    }

    const hideCancelDialog = () => {
        setCancelPopupContent({ ...cancelPopupContent, isDialogVisible: false })
    }

    const warningHideDialog = () => {
        setWarningPopupcontent({ ...WarningPopupcontent, isDialogVisible: false })
    }

    const isUploaded = (name: string) =>
        attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

    const onUploadClick = (fileList: Array<File>) => {
        dispatch(RequisitionAction?.setIsChangesOccured(true))
        setAttachmentError("");
        const filteredList = [
            ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
        ];
        if (filteredList.length > 0 && filteredList.length <= 5) {
            setAttachmentError("");
            let totalSize = 0;
            filteredList.forEach((file: File) => {
                totalSize = totalSize + (file.size || 0);
            });
            if (totalSize <= 5000000) {
                setAttachmentError("");
                const formData = new FormData();
                formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

                for (let i = 0; i < filteredList.length; i++) {
                    formData.append("Files", filteredList[i] as any);
                }
                dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
            } else {
                setAttachmentError("Please Upload files without exceeding maximum size of 5MB");
            }
        } else if (fileList.length > 5) {
            setAttachmentError(
                "Please Upload files without exceeding maximum limit of 5 files"
            );
        } else {
            if (fileList.length > 0 && !filteredList.length) {
                setAttachmentError("All files are uploaded try to add new files");
            } else {
                setAttachmentError("Choose at least 1 file to upload");
            }
        }
    };

    const getLinkedAttachmentsCount = (asset: any) => {
        const filteredArr = asset?.attachments?.filter((i: any) => !!attachmentsList?.find((doc: any) => doc.fileName === i.fileName))
        return filteredArr?.length ? filteredArr?.length : 0;
    }

    const onRemoveAttachment = (index: any) => {
        const findattachment = attachmentsList?.find((_attachment: any, i: any) => index === i);
        const assetArr = [];
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        if (findattachment) {
            assetDetailListTemp?.attachments?.forEach((assetVal: any) => {
                const findAttch = (assetVal?.fileName === findattachment?.fileName);
                if (findAttch) {
                    assetArr.push(assetVal)
                }
            })
            reactivationAssets?.forEach((asset: any) => {
                const attachment = asset?.attachments;
                const findAttchInCartAsset = attachment?.find((attch: any) => attch?.fileName === findattachment?.fileName);
                if (findAttchInCartAsset) {
                    assetArr.push(asset)
                }
            })
        }
        if (assetArr.length) {
            setAttachmentError("The attachment file cannot be deleted. File linked to the item.");
        }
        else {
            dispatch(RequisitionAction?.setIsChangesOccured(true))
            const tempAssetsDetails = assetDetails;
            if (tempAssetsDetails?.attachments?.length) {
                tempAssetsDetails.attachments = tempAssetsDetails?.attachments?.filter((attach: any) => attach?.fileName !== findattachment.fileName)
            }
            // setAssetDetail(tempAssetsDetails);
            dispatch(setReactivationAssetDetails(tempAssetsDetails));
            const newArr = attachmentsList.slice();
            newArr.splice(index, 1);
            const assets = reactivationAssets.map((asset: any) => {
                const attachments = asset?.attachments?.filter((attach: any) => !!newArr?.find((doc: any) => doc.fileName === attach.fileName))
                return { ...asset, attachments };
            })
            const newFileList = JSON.parse(JSON.stringify(documentList));
            newFileList.splice(index, 1);
            setDocumentList(newFileList);
            dispatch(TransferAction.setAssetData(assets));
            dispatchRemoveAttachment(newArr);
            setAttachmentError("");
        }
    }

    const hideDialogAsset = () => {
        setAddNewAssetAlert(false)
    }

    const onClickAdd = () => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        let nextAssetIndex = 0;
        assetDetailListTemp.forEach((item: any) => {
            if (item.assetIndex > nextAssetIndex) {
                nextAssetIndex = item.assetIndex;
            }
        });
        nextAssetIndex = nextAssetIndex + 1;
        setAddNewAssetAlert(true)
        const asset: any = initialState;
        asset.assetIndex = nextAssetIndex;
        assetDetailListTemp.push(asset);
        setAssetDetailList(assetDetailListTemp);
    }

    const onClickDelete = (asset: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        if (assetDetailList?.length == 1) {
            onCancelClick(true);
        } else {
            let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
            const list = assetDetailListTemp?.filter((item: any) => item.assetIndex !== asset.assetIndex && item.assetNumber !== asset.assetNumber);
            list?.map((item?: any, index?: any) => {
                if (item?.assetIndex > asset?.assetIndex) {
                    item.assetIndex = item.assetIndex - 1;
                }
            })

            const reactivationAssetslist = reactivationAssets?.filter((item: any) => item.assetIndex !== asset.assetIndex && item.assetNumber !== asset.assetNumber);
            reactivationAssetslist?.map((item?: any, index?: any) => {
                if (item?.assetIndex > asset?.assetIndex) {
                    item.assetIndex = item.assetIndex - 1;
                }
            })

            setAssetDetailList(list);
            dispatch(TransferAction.setAssetData(reactivationAssetslist));
        }
    }

    const onClicktLinkAttachment = (e: any, index: any) => {
        const attachmentButton: any = isAttachmentBtnClicked;
        attachmentButton[index] = !attachmentButton[index];
        setIsAttachmentBtnClicked(JSON.parse(JSON.stringify(attachmentButton)))
        e.preventDefault();
        e.stopPropagation();
    }

    const onCloseLinkAttachment = (e: any) => {
        setIsAttachmentBtnClicked([])
        e.preventDefault();
        e.stopPropagation();
    }

    const onChangeLinkAttachment = (event: any, attachment: any, reason: any, index: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        event?.preventDefault();
        const asset = reason;
        if (event?.target?.checked) {
            if (!asset.attachments?.map((x: any) => x.fileName)?.includes(attachment?.fileName)) {
                asset.attachments = [...(asset.attachments || []), attachment];
            }
        } else {
            asset.attachments = [
                ...asset.attachments.filter((x: any) => x.fileName !== attachment?.fileName),
            ];
        }
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp.forEach((assetItem: any) => {
            if (assetItem?.assetIndex === asset?.assetIndex) {
                assetItem.attachments = asset?.attachments;
            }
        });
        setAssetDetailList(assetDetailListTemp)
    }


    const onChangeOdometerHourMeter = (item: any, asset: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp?.forEach((assetItem: any) => {
            if (assetItem?.assetIndex === asset?.assetIndex) {
                const value = item?.target?.value;
                // Different validation based on field type
                const isHourMeter = isHourMeterField(assetItem);
                
                let regEx;
                if (isHourMeter) {
                    // Hour Meter: no decimals allowed
                    regEx = /^\d{0,9}$/;
                } else {
                    // Mileage/Odometer: allow up to 1 decimal place
                    regEx = /^\d{0,8}(\.\d{0,1})?$/;
                }
                
                // Allow empty string or if value matches regex
                const checkNumber = regEx.test(value) || value === '';
                if (!checkNumber) {
                    return;
                }
                
                assetItem.odometerHourMeter = value;
                const errors = { ...validateOdometer(assetItem) };
                assetItem.odometerHourMeterError = errors?.odometerHourMeterError;
                assetItem.isValid = validate(assetItem)?.isValid;
                return
            }
        });
        setAssetDetailList(assetDetailListTemp)
    }

    const onBlurOdometerHourMeter = (event: any, asset: any) => {
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp?.forEach((assetItem: any) => {
            if (assetItem?.assetIndex === asset?.assetIndex) {
                const isHourMeter = isHourMeterField(assetItem);
                
                if (assetItem.odometerHourMeter && assetItem.odometerHourMeter !== '') {
                    if (isHourMeter) {
                        // Hour Meter: keep as is (integer)
                        assetItem.odometerHourMeter = assetItem.odometerHourMeter.toString();
                    } else {
                        // Mileage/Odometer: Format with 1 decimal place (no commas)
                        assetItem.odometerHourMeter = parseFloat(assetItem.odometerHourMeter).toFixed(1);
                    }
                }
                
                const errors = { ...validateOdometer(assetItem) };
                assetItem.odometerHourMeterError = errors?.odometerHourMeterError;
                assetItem.isValid = validate(assetItem)?.isValid;
            }
        });
        setAssetDetailList(assetDetailListTemp);
    }

    const onChangeColor = (item: any, asset: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp.forEach((assetItem: any) => {
            if (assetItem?.assetIndex === asset?.assetIndex) {
                assetItem.color = item.target.value;
                const errors = { ...validateColor(assetItem) };
                assetItem.reactivationColorError = errors?.reactivationColorError;
                assetItem.isValid = validate(assetItem)?.isValid;
                return
            }
        });
        setAssetDetailList(assetDetailListTemp)
    }

    const handleLicensePlateChange = (item: any, asset: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp?.forEach((assetItem: any) => {
            if (assetItem?.assetIndex === asset?.assetIndex) {
                assetItem.currentLicensePlateNo = item?.target?.value;
                const errors = { ...validateLicensePlate(assetItem) };
                assetItem.currentLicensePlateError = errors?.currentLicensePlateError;
                assetItem.isValid = validate(assetItem)?.isValid;
                return
            }
        });
        setAssetDetailList(assetDetailListTemp)
    }

    const handleCommentchanges = (item: any, asset: any) => {
        dispatch(RequisitionAction.setIsChangesOccured(true))
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        assetDetailListTemp?.forEach((assetItem: any) => {
            if (assetItem?.assetIndex === asset?.assetIndex) {
                assetItem.reactivationComments = item?.target?.value;
                const errors = { ...validateComments(assetItem) };
                assetItem.reactivationCommentsError = errors?.reactivationCommentsError;
                assetItem.isValid = validate(assetItem)?.isValid;
                return
            }
        });
        setAssetDetailList(assetDetailListTemp)
    }

    const validateComments = (assetItem?: any) => {
        if (assetItem?.reactivationComments?.trim()?.length == 0) {
            assetItem.reactivationCommentsError = "Please enter comments"
        } else if (assetItem?.reactivationComments?.length > 200) {
            assetItem.reactivationCommentsError = "Please enter comments less than 200 characters"
        } else {
            assetItem.reactivationCommentsError = ""
        }
        return assetItem;
    }

    const validateColor = (assetItem?: any) => {
        if (assetItem?.color?.length > 50) {
            assetItem.reactivationColorError = "Please enter color less than 50 characters"
        } else {
            assetItem.reactivationColorError = "";
        }
        return assetItem;
    }

    const validateOdometer = (assetItem?: any) => {
        if (assetItem?.odometerHourMeter?.trim()?.length == 0) {
            assetItem.odometerHourMeterError = "Please enter " + getOdometerLabel(assetItem)?.toLowerCase();
        } else if (assetItem?.odometerHourMeter?.length > 9) {
            assetItem.odometerHourMeterError = "Please enter " + getOdometerLabel(assetItem)?.toLowerCase() + " less than 9 digits"
        } else {
            assetItem.odometerHourMeterError = "";
        }
        return assetItem;
    }

    const validateLicensePlate = (assetItem?: any) => {
        if (assetItem?.currentLicensePlateNo?.length > 30) {
            assetItem.currentLicensePlateError = "Please enter Current License Plate # less than 30 characters"
        } else {
            assetItem.currentLicensePlateError = "";
        }
        return assetItem;
    }

    const validateAttachments = (assetItem?: any) => {
        if (assetItem.attachments?.length == 0) {
            assetItem.attachmentsError = "Please attach atleast one attachment"
        } else {
            assetItem.attachmentsError = ""
        }
        return assetItem;
    }

    const validateAsset = (assetItem: any) => {
        const assetItemTemp = JSON.parse(JSON.stringify(assetItem))
        let isValid = false;
        if (!assetItemTemp?.assetNumber) {
            assetItemTemp.assetError = "Please enter valid Asset #"
        } else if (assetItemTemp?.assetNumber?.length > 15) {
            assetItemTemp.assetError = "Please enter Asset number less than 15 digits."
        } else if (assetItemTemp.assetError?.length === 0) {
            assetItemTemp.assetError = "Click 'Get Asset Info' button to validate";
            isValid = true;
        }
        return { isValid, assetItemTemp };
    }

    const validate = (assets?: IAssets) => {
        let assetItem = JSON.parse(JSON.stringify(assets))
        assetItem.assetError = validateAsset(assetItem).isValid ? "" : validateAsset(assetItem).assetItemTemp.assetError;
        assetItem.odometerHourMeterError = validateOdometer(assetItem)?.odometerHourMeterError;
        assetItem.reactivationColorError = validateColor(assetItem)?.reactivationColorError;
        assetItem.currentLicensePlateError = validateLicensePlate(assetItem)?.currentLicensePlateError;
        assetItem.reactivationCommentsError = validateComments(assetItem)?.reactivationCommentsError;
        assetItem.attachmentsError = validateAttachments(assetItem)?.attachmentsError;
        let isValid = true;
        if (assetItem?.odometerHourMeterError || assetItem?.reactivationColorError || assetItem?.currentLicensePlateError || assetItem?.reactivationCommentsError || assetItem?.attachmentsError) {

            isValid = false;
        }
        return { assetItem, isValid };

    }

    //This useEffect is for the data issue of getting "-." in Status and class.  
    useEffect(() => {
        if (assetDetails?.assetNumber) {
            let assetvalues: any = assetDetails
            let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
            assetDetailListTemp?.forEach((assetItem: any) => {
                if (assetItem?.assetNumber == assetDetails?.assetNumber) {
                    if (assetvalues?.eqStatusDesc !== undefined) {
                        assetItem.eqStatusDesc = (assetvalues?.eqStatusDesc !== "-." && assetvalues?.eqStatusDesc !== null && assetvalues?.eqStatusDesc !== "") ? assetvalues?.eqStatusDesc : "-"
                    }
                    if (assetvalues?.equipmentClassDesc !== undefined) {
                        assetItem.equipmentClassDesc = (assetvalues?.equipmentClassDesc !== "-." && assetvalues?.equipmentClassDesc !== null && assetvalues?.equipmentClassDesc !== "") ? assetvalues?.equipmentClassDesc : "-"
                    }

                    if (assetvalues?.manufacturerName !== undefined) {
                        assetItem.manufacturerName = (assetvalues?.manufacturerName !== "." && assetvalues?.manufacturerName !== null && assetvalues?.manufacturerName !== "") ? assetvalues?.manufacturerName : "-"
                    }
                    assetItem.assetError = "";
                    assetItem.unitNumber = assetDetails.unitNumber;
                    assetItem.modelYear = assetDetails.modelYear;
                    assetItem.description = assetDetails.description;
                    assetItem.serialNumber = assetDetails.serialNumber;
                    assetItem.licensePlateNumber = assetDetails.licensePlateNumber;
                    assetItem.monthlyAmount = assetDetails.monthlyAmount;
                    assetItem.monthRemaining = assetDetails.monthRemaining;
                    assetItem.netBookedValue = assetDetails.netBookedValue;
                    assetItem.glCategory = assetDetails.glCategory;
                    assetItem.isOdometerRequired = assetDetails.isOdometerRequired;
                    assetItem.dateAcquired = assetDetails.dateAcquired ? Moment(assetDetails.dateAcquired).format('MM/DD/YYYY') : '-';
                    assetItem.disposeGainLoss = assetDetails?.disposeGainLoss;
                    assetItem.acquisitionCode = assetDetails?.acquisitionCode;
                    assetItem.accountObject = assetDetails?.accountObject;
                    assetItem.acquisitionCost = assetDetails?.acquisitionCost;
                    assetItem.lifeMonths = assetDetails?.lifeMonths;
                    assetItem.leasedvsOwned = assetDetails?.leasedvsOwned;
                    assetItem.showAssetStatus = assetDetails?.showAssetStatus;
                    assetItem.costCenterNo = assetDetails?.costCenterNo;
                    assetItem.model = assetDetails?.model;
                    assetItem.odometerHourMeter = assetDetails?.glCategory?.toLowerCase()?.includes("trailer") ? "0" : "";
                    assetItem.dateDisposed = assetDetails.dateDisposed ? Moment(assetDetails.dateDisposed).format('MM/DD/YYYY') : '-';
                    assetItem.disposalDate = assetDetails.dateDisposed ? new Date(assetDetails.dateDisposed) : new Date()
                }
            });
            setAssetDetailList(assetDetailListTemp)
        }
    }, [assetDetails])

    // Helper function to determine if field is Hour Meter (no decimals) or Mileage/Odometer (allow decimals)
    const isHourMeterField = (asset: any) => {
        if (asset?.isOdometerRequired) {
            return false;
        }
        return asset?.glCategory?.toLowerCase()?.includes("mower");
    }

    const getOdometerLabel = (asset: any) => {
        let label;
        if (asset?.isOdometerRequired) {
            label = "Mileage"
        } else if (asset?.glCategory?.toLowerCase()?.includes("mower")) {
            label = "Hour Meter"
        } else if ((asset?.assetNumber?.length && asset?.assetNumber && isAssetBtnClicked && !asset?.assetError) || (asset?.isOdometerRequired === false)) {
            label = "Odometer / Meter"
        } else {
            label = "Odometer / Hour Meter"
        }
        return label
    }

    const getVinSerialLabel = (asset: any) => {
        let label = "";
        if (asset?.isOdometerRequired && asset?.assetNumber && isAssetBtnClicked) {
            label = "Vin #"
        } else if ((asset?.assetNumber && isAssetBtnClicked) || (asset?.isOdometerRequired != undefined || asset?.isOdometerRequired == false)) {
            label = "Serial #"
        } else {
            label = "VIN / Serial #"
        }
        return label;
    }

    const onClickAddAsset = () => {
        let assetDetailListTemp = assetDetailList?.length > 0 ? JSON.parse(JSON.stringify(assetDetailList)) : [];
        let validatedAssetList: any = [];
        assetDetailListTemp?.forEach((assetItem: any) => {
            let asset = validate(assetItem);
            if (asset?.assetItem) {
                validatedAssetList.push(asset.assetItem);
            }
        });
        setAssetDetailList(validatedAssetList);
        let isValid = true;
        validatedAssetList.forEach((assetItem: any) => {
            if (assetItem.assetError || assetItem.odometerHourMeterError || assetItem.currentLicensePlateError || assetItem.reactivationColorError || assetItem.reactivationCommentsError || assetItem?.attachmentsError) {
                isValid = false;
                return;
            }
        });
        if (isValid) {
            setSuccessAlert(true)
            setShowCart(true);
            if (mobile) {
                setShowCreateRequisition(false)
                setShowCartClicked(false)
            }
            else {
                setShowCartClicked(true)
                setShowCreateRequisition(true)
            }
            let assetsListTemp = validatedAssetList?.length > 0 ? JSON.parse(JSON.stringify(validatedAssetList)) : []
            assetsListTemp?.forEach((assetItem: any, index?: any) => {
                assetItem.isExist = true;
                assetItem.hide = assetsListTemp.length !== 1
            });
            setShowDispositionInfoAlert(true);
            dispatch(TransferAction.setAssetCartData(assetsListTemp));
            dispatch(TransferAction.setAssetData(validatedAssetList))
        } else {
            let popUpDecriptionTxt = "Please fill all the asset information details"
            setPopupcontent({
                ...Popupcontent,
                titleImg: confirmationBee,
                title: 'Validation',
                isDialogVisible: true,
                isTitleWarning: false,
                subtextcontent: popUpDecriptionTxt,
                primaryBtnText: "",
                outlineBtnText: "Close",
                popupOutlinebtnOnclick: () => {
                    hideDialog();
                },
                isSingleConfirmationBtn: true,
            });
        }
    }

    const hideDialogAddDisposition = () => {
        setShowDispositionInfoAlert(false)
    }


    const revertChangesOnClick = () => {
        APIToReact({
            dispatch,
            transferOrderByIdData
        })
        setIsRevertChanges(true);
    }

    const cancelRequestOnClick = () => {
        setIsCancelRequestClicked(true);
        const cancelOrdersubtext = (
            <div>
                <p>Are you sure you want to cancel the Order</p>
                <p>
                    <b>LEADR Order # : </b>{id}
                </p>
            </div>
        );
        setCancelPopupContent({
            ...cancelPopupContent,
            titleImg: RejectedBee,
            title: "CANCEL ORDER",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: cancelOrdersubtext,
            primaryBtnText: "Yes",
            outlineBtnText: "No",
            isSingleConfirmationBtn: false,
            isCommentboxVisible: true,
            isCommentBoxRequire: true,
            isCompletedReportVisible: false,
            popupOutlinebtnOnclick: () => {
                setIsCancelRequestClicked(false);
                hideCancelDialog();
            },
            popupPrimarybtnOnclick: (comment: any) => {
                if (transferOrderByIdData?.orderStatus == "Saved") {
                    const deleteDraftOrder = {
                        orderId: transferOrderByIdData?.orderId,
                        comments: comment,
                        savedBy: getUserDetails?.emailId
                    };
                    dispatchGetDeleteCartOrderById(deleteDraftOrder)
                } else {
                    cancelOrderRequest({ orderId: transferOrderByIdData?.orderId, savedBy: getUserDetails?.emailId, comments: comment });
                }
                hideCancelDialog();
            }
        });
    }

    return (
        <Reactivations
            getLinkedAttachmentsCount={getLinkedAttachmentsCount}
            WarningPopupcontent={WarningPopupcontent}
            Popupcontent={Popupcontent}
            hideDialog={hideDialog}
            warningHideDialog={warningHideDialog}
            assetDetailList={assetDetailList}
            setAssetDetailList={setAssetDetailList}
            setIsAsserNumberValid={setIsAsserNumberValid}
            setIsAssetBtnClicked={setIsAssetBtnClicked}
            isAssetBtnClicked={isAssetBtnClicked}
            isAddAssetClicked={isAddAssetClicked}
            setIsAddAssetClicked={setIsAddAssetClicked}
            docList={docList}
            onRemoveAttachment={onRemoveAttachment}
            attachmentError={attachmentError}
            setAttachmentError={setAttachmentError}
            onUploadClick={onUploadClick}
            documentList={documentList}
            setDocumentList={setDocumentList}
            onClickAdd={onClickAdd}
            addNewAssetAlert={addNewAssetAlert}
            hideDialogAsset={hideDialogAsset}
            onClickDelete={onClickDelete}
            onClicktLinkAttachment={onClicktLinkAttachment}
            onCloseLinkAttachment={onCloseLinkAttachment}
            isAttachmentBtnClicked={isAttachmentBtnClicked}
            onChangeLinkAttachment={onChangeLinkAttachment}
            onChangeOdometerHourMeter={onChangeOdometerHourMeter}
            onBlurOdometerHourMeter={onBlurOdometerHourMeter}
            onChangeColor={onChangeColor}
            handleLicensePlateChange={handleLicensePlateChange}
            handleCommentchanges={handleCommentchanges}
            getOdometerLabel={getOdometerLabel}
            getVinSerialLabel={getVinSerialLabel}
            onClickAddAsset={onClickAddAsset}
            hideDialogAddDisposition={hideDialogAddDisposition}
            showDispositionInfoAlert={showDispositionInfoAlert}
            cartAssets={cartAssets}
            isEditOrder={isEditOrder}
            transferOrderByIdData={transferOrderByIdData}
            revertChangesOnClick={revertChangesOnClick}
            cancelRequestOnClick={cancelRequestOnClick}
            cancelPopupContent={cancelPopupContent}
            hideCancelDialog={hideCancelDialog}
            showCart = {showCart}
            reactivationAssets = {reactivationAssets}
            isHourMeterField={isHourMeterField}
        />
    )
}
export default ReactivationsContainer;